<script>
	import CategoryPill from './CategoryPill.svelte';

	let { article } = $props();

	function formatDate(dateStr) {
		const date = new Date(dateStr + 'T00:00:00');
		return date.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		});
	}
</script>

<a
	href="/articles/{article.id}/"
	class="group flex items-center gap-4 rounded-lg border-l-3 border-wine/30 bg-altar-white px-4 py-3 transition-all duration-200 hover:border-wine hover:bg-parchment-dark hover:shadow-sm"
>
	<img
		src={article.imageUrl || '/images/article-placeholder.svg'}
		alt={article.title}
		class="h-16 w-16 flex-shrink-0 rounded object-cover md:h-20 md:w-20"
		loading="lazy"
	/>

	<div class="min-w-0 flex-1">
		<div class="flex items-center gap-2">
			{#if article.category}
				<CategoryPill category={article.category} />
			{/if}
			<span class="text-xs text-navy-muted">{formatDate(article.date)}</span>
		</div>
		<h3 class="mt-1 truncate font-heading text-lg font-semibold text-navy group-hover:text-wine">
			{article.title}
		</h3>
	</div>
</a>
